document.addEventListener("DOMContentLoaded", () => {
  initializeSearchBars();
  fixSearchWidth();
});

function fixSearchWidth() {
  const searchBarsInput = document.querySelectorAll(".search-bar__input");

  searchBarsInput.forEach((input) => {
    const placeholder = input.getAttribute("placeholder");

    if (placeholder) {
      const currentSize = input.getAttribute("size");

      if (!currentSize || parseInt(currentSize) > placeholder.length) {
        input.setAttribute("size", placeholder.length);
      }
    }
  });
}

fixSearchWidth();

function initializeSearchBars() {
  const searchBars = document.querySelectorAll(".search-bar");

  searchBars.forEach((searchBar) => {
    const searchInput = searchBar.querySelector(".search-bar__input");
    const resultsContainer = searchBar.querySelector(".search-bar__results");

    if (!searchInput || !resultsContainer) return;

    let debounceTimer;

    searchInput.addEventListener("input", (e) => {
      clearTimeout(debounceTimer);

      const searchTerm = e.target.value.trim();

      if (searchTerm.length < 3) {
        resultsContainer.style.display = "none";
        return;
      }

      debounceTimer = setTimeout(() => {
        performSearch(searchTerm, resultsContainer);
      }, 300);
    });

    // Close results when clicking outside
    document.addEventListener("click", (e) => {
      if (!searchBar.contains(e.target)) {
        resultsContainer.style.display = "none";
      }
    });

    // Prevent form submission if using predictive search
    searchBar.addEventListener("submit", (e) => {
      if (
        e.target.querySelector(".search-bar__input").value.trim().length < 3
      ) {
        e.preventDefault();
      }
    });
  });
}

async function performSearch(searchTerm, resultsContainer) {
  try {
    const response = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=product`
    );

    if (!response.ok) {
      throw new Error("Search request failed");
    }

    const data = await response.json();
    const products = data.resources.results.products;

    if (products.length > 0) {
      displayResults(products, resultsContainer);
    } else {
      displayNoResults(resultsContainer);
    }

    resultsContainer.style.display = "block";
  } catch (error) {
    console.error("Search error:", error);
    resultsContainer.style.display = "none";
  }
}

function displayResults(products, resultsContainer) {
  const maxResults = 5; // Limit number of results
  const displayProducts = products.slice(0, maxResults);

  let html = `
    <ul class="search-bar__results-list">
      ${displayProducts
        .map(
          (product) => `
        <li class="search-bar__results-item">
          <a href="${product.url}" class="search-bar__results-link">
            <img 
              src="${product.image || "no-image.jpg"}" 
              alt="${product.title}" 
              class="search-bar__results-image"
              onerror="this.src='{{ 'no-image.jpg' | asset_url }}'"
            >
            <div class="search-bar__results-info">
              <span class="search-bar__results-title">${product.title}</span>
            </div>
          </a>
        </li>
      `
        )
        .join("")}
    </ul>
    <a href="/search?q=${encodeURIComponent(
      products[0].title.split(" ")[0]
    )}" class="search-bar__view-all">
      Ver todos os resultados
    </a>
  `;

  resultsContainer.innerHTML = html;
}

function displayNoResults(resultsContainer) {
  resultsContainer.innerHTML = `
    <div class="search-bar__no-results">
      Nenhum resultado encontrado
    </div>
  `;
}

function formatMoney(cents) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const value = parseInt(cents || 0) / 100;
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
}
